import { ILinkedEmail } from '@/entities/admin-app/email';
import { LinkEmailModal } from '@/containers/pages/user/components/sections/linked-emails/modals/LinkEmailModal';
import { CreateEmailAccount } from '@/containers/pages/user/components/sections/linked-emails/modals/CreateEmailAccount';

interface Props {
  opened: boolean;
  isOpenedCreateModal: boolean;
  filialId?: number | null;
  editUser: boolean;
  isLoading: boolean;
  isSuccess: boolean;

  closeCreateModal(): void;
  close(): void;
  handleAddEmail(email: ILinkedEmail): Promise<void>;
}

export const LinkEmailsModals = (props: Props) => {
  const {
    opened,
    isOpenedCreateModal,
    filialId,
    editUser,
    isLoading,
    isSuccess,
    closeCreateModal,
    close,
    handleAddEmail
  } = props;

  const visibleCreateEmailModal = isOpenedCreateModal && filialId;

  return (
    <>
      <LinkEmailModal
        opened={opened}
        handleClose={close}
        handleAddEmail={handleAddEmail}
        filialId={filialId}
        isLoading={isLoading}
        isSuccess={isSuccess}
        editUser={editUser}
      />
      {visibleCreateEmailModal && (
        <CreateEmailAccount
          handleClose={closeCreateModal}
          opened={isOpenedCreateModal}
          handleAddEmail={handleAddEmail}
          filialId={filialId}
        />
      )}
    </>
  );
};
